import React from 'react';
import {EditButton} from 'react-admin';

const CampaignEditButton = (props) => {
    return (<EditButton {...props} disabled={['done', 'sending'].includes(props.record.state)}/>);
};

export default CampaignEditButton;